import { useEffect, useState, useRef, useCallback } from "react"
import { Row, Col, message } from 'antd';
import { HomeRouter } from './router'
import { NavLink } from 'react-router-dom'
import { PostIp, GetCourseContent } from "./ajax";

function Myhome(props) {
  const [show, setShow] = useState(false)
  const [preventlayer, setPrevent] = useState(false)
  const [down, setDown] = useState(false)
  useEffect(() => {
    document.documentElement.style.overflow = show ? 'hidden' : ''
  }, [show])

  const homeContent = useRef()

  const postip = async () => {
    let res = await PostIp()
    if (res.city === '台湾') {
      sessionStorage.local = res.city
      window._czc.push(["_trackEvent", 'IP-台湾', '弹框', '', 'tips']);
      window._czc.push(["_trackEvent", 'IP-台湾', '弹框', '关闭', 'tipsclose']);
      window._czc.push(["_trackEvent", 'IP-台湾', '弹框', '跳转', 'switchtaiwan']);
      setPrevent(true)
    }
    else {
      window._czc.push(["_trackEvent", 'IP-其他', '未弹框	', '/', 'tips']);
      // window._czc.push(["_trackEvent", '判断IP-其他地区', '系统弹框引导	', '/', 'tips']);
      setPrevent(false)
    }

  }

  useEffect(() => {
    if (sessionStorage.local) {
      return
      // if (sessionStorage.local === '台湾') {
      //   window._czc.push(["_trackEvent", '判断IP-台湾地区', '系统弹框引导', '/', 'tips']);
      //   setPrevent(true)
      // }
      // window._czc.push(["_trackEvent", '判断IP-其他地区', '未弹框	', '/', 'tips']);
      // setPrevent(false)
    }
    else {
      postip()
    }
  }, [])

   const [courseList, setCourseList] = useState([]);
   const getCourse = useCallback(async () => {
     let res = await GetCourseContent();
     if (res.code !== 0) {
       message.error(res.message);
     } else {
       let courseArr = res.result
         .filter((i) => i.parentCourseId === 0 && i.showStatus === 1)
         .sort((a, b) => a.category - b.category);
         console.log(courseArr);
       setCourseList(courseArr);
     }
   }, []);

   useEffect(() => {
     getCourse();
   }, [getCourse]);
  return (
    <div className="home-box">
      {preventlayer ? (
        <Row>
          <Col sm={24} xs={24} md={24} lg={0} xl={0}>
            {
              <div id="tips" className="toasttips">
                <div className="toastbox2">
                  <div
                    id="tipsclose"
                    className="closex2"
                    onClick={() => setPrevent(false)}
                  >
                    X
                  </div>
                  <div className="toastcontent2">
                    <div>是否切換到繁體中文站點？</div>
                    <div>
                      繁體中文站點報名成功將使用 Telegram
                      軟件改圖，繁體中文站點與本站点的數據不互通，不可交叉報名，請知悉
                    </div>
                  </div>
                  <a
                    id="switchtaiwan"
                    className="conbutton2"
                    href="https://www.krenzartwork.com/"
                  >
                    <span>確定</span>
                  </a>
                </div>
              </div>
            }
          </Col>
          <Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
            {
              <div id="tips" className="toasttips">
                <div className="toastbox">
                  <div
                    id="tipsclose"
                    className="closex"
                    onClick={() => setPrevent(false)}
                  >
                    X
                  </div>
                  <div className="toastcontent">
                    <div>是否切換到繁體中文站點？</div>
                    <div>
                      （繁體中文站點報名成功將使用 Telegram
                      軟件改圖，繁體中文站點與本站点的數據不互通，不可交叉報名，請知悉）
                    </div>
                  </div>
                  <a
                    id="switchtaiwan"
                    className="conbutton"
                    href="https://www.krenzartwork.com/"
                  >
                    <span>確定</span>
                  </a>
                </div>
              </div>
            }
          </Col>
        </Row>
      ) : (
        ""
      )}
      <div className="home-header">
        <Row>
          <Col sm={24} xs={24} md={24} lg={0} xl={0}>
            <PhoneNavigation
              {...props}
              show={show}
              setDown={setDown}
              setShow={setShow}
            />
            <PhoneLeftside
              {...props}
              down={down}
              setDown={setDown}
              show={show}
              setShow={setShow}
              courseList={courseList}
            />
          </Col>

          <Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
            <PcNavigation {...props} courseList={courseList} />
          </Col>
        </Row>
      </div>
      <div className="home-content" ref={homeContent}>
        <HomeRouter {...props} show={show} setShow={setShow} />
      </div>
      {/* <BottomIfor/> */}
      <div
        onClick={() => {
          setShow(!show);
        }}
        style={
          show
            ? {
                overflow: "hidden",
                display: "block",
                position: "fixed",
                backgroundColor: "rgba(0,0,0,0.7)",
                top: "0px",
                width: "100%",
                height: "100%",
                zIndex: 21,
              }
            : { display: "none" }
        }
      ></div>
    </div>
  );
}


function PcNavigation(props) {
 let {courseList}=props
  return (
    <div style={{ width: "100%", backgroundColor: "#ededed" }}>
      <div className="header-nav">
        <NavLink to="/">
          <div className="header-nav-logo"></div>
        </NavLink>
        <div className="header-nav-direction">
          <NavLink
            className="nav-tag"
            activeClassName="nav-link-style"
            to="/"
            exact
          >
            <div>
              <div className="nav-tag-home">
                <span>首页</span>
              </div>
              <div className="nav-tag-homepage">
                <div>
                  <span>HOME</span>
                  <span> PAGE</span>
                </div>
              </div>
            </div>
          </NavLink>
          <div className="nav-tag">
            <div className="nav-tag-home">
              <span>课程介绍</span>
            </div>
            <div className="nav-tag-homepage">
              <div>
                <span> COURSE </span>
                <span> INTRODUCTION </span>
              </div>
            </div>
            <div className="course-list">
              {courseList.map((i) => {
                return (
                  <div key={i.id}>
                    <NavLink className="nav-style" to={`/course/${i.id}`}>
                      <div className="cn-smtitle">
                        <span>{i.nameCN}</span>
                      </div>
                      <div className="en-smtitle">
                        <span>{i.name}</span>
                      </div>
                    </NavLink>
                  </div>
                );
              })}
              <div>
                <a
                  href="https://www.zhihu.com/org/kkmo-fa-xue-yuan/columns"
                  target="_blank"
                  rel="noreferrer"
                  className="nav-style"
                >
                  <div className="cn-smtitle">
                    <span>学生结课心得</span>
                  </div>
                  <div className="en-smtitle">
                    <span>STUDY NOTES</span>
                  </div>
                </a>
              </div>
              <div>
                <NavLink className="nav-style" to={`/schedule`}>
                  <div className="cn-smtitle">
                    <span>2026年课表</span>
                  </div>
                  <div className="en-smtitle">
                    <span>2026 SCHEDULE</span>
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
          <NavLink
            className="nav-tag"
            activeClassName="nav-link-style"
            to="/teach"
          >
            <div>
              <div className="nav-tag-home">
                <span>教学团队</span>
              </div>
              <div className="nav-tag-homepage">
                <div>
                  <span>TEACHING </span>
                  <span> TEAM</span>
                </div>
              </div>
            </div>
          </NavLink>
          <NavLink
            className="nav-tag"
            activeClassName="nav-link-style"
            to="/notes"
          >
            <div>
              <div className="nav-tag-home">
                <span>新闻活动</span>
              </div>
              <div className="nav-tag-homepage">
                <div>
                  <span>NEWS</span>
                  <span> & EVENTS</span>
                </div>
              </div>
            </div>
          </NavLink>
          <NavLink
            className="nav-tag"
            activeClassName="nav-link-style"
            to="/commonproblem/seid/0"
          >
            <div>
              <div className="nav-tag-home">
                <span>常见问题</span>
              </div>
              <div className="nav-tag-homepage">
                <div>
                  <span>COMMON </span>
                  <span> PROBLEM</span>
                </div>
              </div>
            </div>
          </NavLink>

          {/* <div className="nav-tag"><img src="/search.jpg"/></div> */}
        </div>
      </div>
    </div>
  );
}
function PhoneNavigation(props) {
  let { show, setShow } = props
  return (
    <div className="Phone">
      <div className="ph-header-logo"></div>
      {/* <div className="search-icon"></div> */}
      {show ? <div >
        <div className="menu-box" onClick={() => setShow(false)} style={{ fontSize: '16px' }}>MENU</div>
      </div>
        :
        <div style={{ fontSize: '16px' }} onClick={() => {
          setShow(true)
        }} className="menu-box">
          MENU
        </div>}
    </div>
  )
}

function PhoneLeftside(props) {
  let { show, setShow, down, setDown,courseList } = props

  useEffect(() => {
  })
  return (
    <div>
      <div
        className="dropdown-nav"
        style={show ? { left: 0 } : { left: -3.3 + "rem" }}
      >
        <div className="dropdown-box">
          <NavLink
            to="/"
            onClick={() => {
              setShow(false);
            }}
          >
            <div className="drop-nav">
              <span className="cn-title">首页</span>
              <span className="en-title">HOME PAGE</span>
              <div className="bottom-div"></div>
              <div className="indicate-icon"></div>
            </div>
          </NavLink>
          <div
            className="drop-nav"
            onClick={() => {
              setDown(!down);
            }}
          >
            <span className="cn-title">课程介绍</span>
            <span className="en-title">COURSE INTRODUCTION</span>
            <div className="bottom-div"></div>
            <div
              className="indicate-icon"
              style={
                down
                  ? { transform: `rotate(90deg)` }
                  : { transform: `rotate(0deg)` }
              }
            ></div>
            <div className="course-list2">
              <div
                className="course-list-show"
                style={down ? { height: "auto" } : { height: 0 }}
              >
                {courseList.map((i) => {
                  return (
                    <NavLink
                      key={i.id}
                      to={`/course/${i.id}`}
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <div>
                        <span className="cn-title">{i.nameCN}</span>
                        <span className="en-title2">{i.name}</span>
                      </div>
                    </NavLink>
                  );
                })}

                <a
                  href="https://www.zhihu.com/org/kkmo-fa-xue-yuan/columns"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div>
                    <span className="cn-title">学生结课心得</span>
                    <span className="en-title2">STUDY NOTES</span>
                  </div>
                </a>
                <NavLink
                  to={`/schedule`}
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  <div>
                    <span className="cn-title">2026年课表</span>
                    <span className="en-title2">2026 SCHEDULE</span>
                  </div>
                </NavLink>
              </div>
            </div>
          </div>

          <NavLink
            to="/teach"
            onClick={() => {
              setShow(false);
            }}
          >
            <div className="drop-nav">
              <span className="cn-title">教学团队</span>
              <span className="en-title">TEACHING TEAM</span>
              <div className="bottom-div"></div>
              <div className="indicate-icon"></div>
            </div>
          </NavLink>
          <NavLink
            to="/notes"
            onClick={() => {
              setShow(false);
            }}
          >
            <div className="drop-nav">
              <span className="cn-title">新闻活动</span>
              <span className="en-title">NEWS & EVENTS</span>
              <div className="bottom-div"></div>
              <div className="indicate-icon"></div>
            </div>
          </NavLink>
          <NavLink
            to="/commonproblem/seid/0"
            onClick={() => {
              setShow(false);
            }}
          >
            <div className="drop-nav">
              <span className="cn-title">常见问题</span>
              <span className="en-title">COMMON PROBLEM</span>
              <div className="bottom-div"></div>
              <div className="indicate-icon"></div>
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default Myhome